export const TEST_ID = 'serviceHistoryRow';

export const VOID_TEST_ID = 'serviceHistoryRowVoid';

export const PHOTOS_TEST_ID = 'serviceHistoryRowPhotos';
